import { XIconMobile } from "../Icon/XIcon";
import classes from "./CloseWindowButton.module.css";
import { useDeviceContext } from "src/context/device-context";

export function CloseWindowButton({ onClick }) {
  const { isMobile } = useDeviceContext();
  return (
    <div
      role="button"
      tabIndex="0"
      className={`${classes.exit} ${isMobile ? classes.mobile : ""}`}
      onKeyDown={(e) => e.key === "Enter" && onClick()}
      onClick={() => onClick()}>
      <XIconMobile />
    </div>
  );
}
